import { WorkshopService } from './../services/workshop.service';
import { RepairService } from './../services/repair.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { LoggerService, InventoryService, AuthService } from '../services';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { CreateVariantComponent } from './create-variant/create-variant.component';
import { ImagePopUpDialog, ImageDetails } from '../shared/Image-popup/image-popup.component';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ScreenLayouts } from '../core/constants/screen-layouts';
import { TranslateService } from '@ngx-translate/core';
import { PartRepairInventoryComponent } from './part-repair-inventory/part-repair-inventory.component';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs-compat';
import { take, takeUntil } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { LocalStorageKeys } from '../core/constants';
import { UserService } from '../services/users.service';
import { UserPrivileges } from '../core/enums/userPrivileges';
import { UserRoles } from '../core/constants/user-roles';
import { AddPartComponent } from './add-part/add-part.component';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';
import { AppSettings } from '../services/app.settings';
import { S3BucketFoldersKeys } from '../core/enums/S3BucketFoldersKeys';


@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent implements OnInit {
  @ViewChild('inventryTable', { static: false }) table: any;
  bikeDetails: any;
  isMobile: boolean = false;
  invDialogRef: MatDialogRef<ImagePopUpDialog>;
  parts: ImageDetails = null;
  lastCloseResult: string;
  config: MatDialogConfig = {
    disableClose: false,
    width: '55%',
    height: '65%',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    }
  };
  types = {
    Create: 'Create',
    Update: 'Update'
  };
  loadingIndicator: boolean = false;

  public readonly LAYOUT = ScreenLayouts;
  public layout: number = this.LAYOUT.MD;
  allWorkshops: any[];
  selectedWorkshop: number;
  allworkshopPartDetails: any;

  protected partsList: any[];

  public partCtrl: FormControl = new FormControl();
  public partFilterCtrl: FormControl = new FormControl();
  public filteredParts: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();
  partIds: any;
  allInventoryDetails: any[] = [];
  readonly partAccessConst = 'INVENTORY.PARTS';
  isAdminOrMaintenance: any = false;

  constructor(
    private loggerService: LoggerService,
    private inventoryService: InventoryService,
    private repairService: RepairService,
    private dialog: MatDialog,
    public breakpointObserver: BreakpointObserver,
    private translate: TranslateService,
    private workshopService: WorkshopService,
    public authService: AuthService,
    public userService: UserService,
    private appSettings: AppSettings
  ) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (document.documentElement.clientWidth < 768)) {
      this.isMobile = true;
    }
  }

  openDeleteDialog(row: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: { "message": "COMMON.DELETE_CONFIRMATION_MSG" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.inventoryService.deletePartVariant(row.Id).subscribe(
          _ => {
            this.loggerService.showSuccessfulMessage('Item deleted successfully.');
            // Reload current data after deletion
            this.loadInventory();
          },
          error => {
            this.loggerService.showErrorMessage('Deleting inventory item failed.');
          }
        );
      }
    });
  }

  private loadInventory() {
    this.loadingIndicator = true;
    // reload existing data source
    this.inventoryService.getAllPartsAndVariants().subscribe(data => {
      this.allInventoryDetails = data;
      this.filterBasedOnWorkshop();
      this.loadingIndicator = false;
    }, _ => {
      this.loadingIndicator = false;
    });
  }

  onResize() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (document.documentElement.clientWidth < 768)) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  openCreateUpdateVariantDialog(type: string, variant: any): void {
    const dialogRef = this.dialog.open(CreateVariantComponent, {
      width: '300px',
      data: { type: type, variant: variant }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  ngOnInit() {
    let loggedInUser = JSON.parse(localStorage.getItem(LocalStorageKeys.USER_DETAILS));
    let authToken = JSON.parse(localStorage.getItem(LocalStorageKeys.OAUTH_TOKEN));
    this.isAdminOrMaintenance = this.authService.isAdminOrManitanance();
    if (!this.isAdminOrMaintenance && loggedInUser && authToken && authToken._claims
      && authToken._claims[0] == UserRoles.STREET_TEAM)
      this.hasWorkshopPrivilegeUser(loggedInUser.UserId);

    this.manageScreenWidth();
    // this.getAllPartsAndVariants();
    this.getAllWorkshopsWithStreetTeam();
    this.selectedWorkshop = 1; // load Bike Garage default
    this.getAllPartVariantsByFilter(this.selectedWorkshop);
    this.loadAllParts();
    this.partFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterParts();
      });
    this.translate.onLangChange
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        console.log('🌍 Language changed to:', this.translate.currentLang);
        this.applyTranslationLogic(this.bikeDetails);
        this.applyTranslationLogic(this.allInventoryDetails);
        this.applyTranslationLogic(this.partsList); // Update filter list translations

        // Force table refresh to pick up new translations
        this.bikeDetails = [...this.bikeDetails];

        // Refresh filter
        this.filterParts();
      });

    // Listen for background updates from inventory service (e.g. after seeding completion)
    this.inventoryService.onInventoryUpdated
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        console.log('InventoryComponent: Received update notification, reloading data...');
        this.getAllPartVariantsByFilter(this.selectedWorkshop);
        this.loadAllParts();
      });

    // Listen for seeding status to show global loading indicator
    this.inventoryService.isSeeding$
      .pipe(takeUntil(this._onDestroy))
      .subscribe((isSeeding) => {
        // If seeding is in progress, force loading indicator on
        // If seeding just finished, it will stay on briefly until reload completes (via getAllPartVariantsByFilter)
        if (isSeeding) {
          this.loadingIndicator = true;
        }
      });
  }

  protected filterParts() {
    if (!this.partsList) {
      return;
    }
    // get the search keyword
    let search = this.partFilterCtrl.value;
    if (!search) {
      this.filteredParts.next(this.partsList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter
    this.filteredParts.next(
      this.partsList.filter(part => part.Name.toLowerCase().indexOf(search) > -1)
    );
  }

  loadAllParts() {
    this.inventoryService.getAllPartDetails().subscribe(data => {
      this.partsList = data;
      this.applyTranslationLogic(this.partsList); // Apply translations
      // load the initial part list
      this.filteredParts.next(this.partsList.slice());
      //set selected part
      this.partCtrl.patchValue(this.partsList);
    }, error => {
      this.loggerService.showErrorMessage(error);
    });
  }

  filterByParts(opened: boolean) {
    if (!opened) {
      if (this.partCtrl.value != null) {
        this.partIds = [];
        const selectedParts = this.partCtrl.value as any[];
        selectedParts.forEach((part) => {
          // include the selected part id
          this.partIds.push(part.PartId);
          // include all descendant parts of the selected parent
          const descendants = this.getDescendantPartIds(part.PartId);
          if (descendants && descendants.length) {
            this.partIds = this.partIds.concat(descendants);
          }
        });
        // remove duplicates
        this.partIds = Array.from(new Set(this.partIds));
      }
      if (!this.partIds || this.partIds.length < 1) {
        let errorMsg = "";
        let actionLabel = "";
        this.translate.get("INVENTORY.ERROR_MSG").subscribe(name => {
          errorMsg = name;
        });
        let errorcategory = "COMMON.CLOSE";
        this.translate.get(errorcategory).subscribe(name => {
          actionLabel = name;
        });
        return this.loggerService.showErrorMessage(errorMsg, actionLabel, {
          duration: 3000
        });
      }
      else {
        this.getAllInventoriesByFilter();
      }
    }
  }

  private getDescendantPartIds(parentPartId: number): number[] {
    if (!this.partsList || !parentPartId) { return []; }
    const descendants: number[] = [];
    const stack: number[] = [parentPartId];
    while (stack.length) {
      const currentParentId = stack.pop();
      const children = (this.partsList || []).filter(p => p.ParentId === currentParentId);
      children.forEach(child => {
        descendants.push(child.PartId);
        stack.push(child.PartId);
      });
    }
    // exclude the root parent id itself from descendants
    return descendants.filter(id => id !== parentPartId);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredParts.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.partCtrl.patchValue(val, { emitEvent: false });
        } else {
          this.partCtrl.patchValue([], { emitEvent: false });
        }
      });
  }

  getAllInventoriesByFilter() {
    this.bikeDetails = [];
    this.partIds.forEach(partId => {
      let inventoryDetails = this.allInventoryDetails.filter(x => x.PartId == partId);
      if (this.bikeDetails.length == 0)
        this.bikeDetails = inventoryDetails;
      else {
        for (var item in inventoryDetails) {
          this.bikeDetails.push(inventoryDetails[item]);
        }
      }
      this.applyTranslationLogic(this.bikeDetails);
    });
    console.log('→ UI Table Filtered - Final Count:', this.bikeDetails.length);
  }

  manageScreenWidth() {
    const breakpoints = Object.keys(this.LAYOUT).map(k => this.LAYOUT[k]);
    breakpoints.forEach((maxWidth, index) => {
      const minWidth = (index > 0) ? breakpoints[index - 1] : 0;
      this.breakpointObserver
        .observe([`(min-width: ${minWidth}px) and (max-width: ${maxWidth - 1}px)`])
        .subscribe((state: BreakpointState) => {
          if (!state.matches) { return; }
          this.layout = maxWidth;
          //console.log('Layout', this.layout);
        });
    });
  }

  getAllPartsAndVariants() {
    this.loadingIndicator = true;
    this.inventoryService.getAllPartsAndVariants().subscribe(data => {
      this.bikeDetails = data;
      this.allInventoryDetails = data;
      this.loadingIndicator = false;
    }, error => {
      this.loadingIndicator = false;
      this.loggerService.showErrorMessage('Getting parts and variants failed');
    });
  }

  getAllPartVariantsByFilter(workshopId) {
    this.loadingIndicator = true;

    forkJoin([
      this.inventoryService.getAllPartVariantsByFilter(workshopId),
      this.inventoryService.getAllPartDetails()
    ]).subscribe(([variantsData, allParts]) => {
      this.allworkshopPartDetails = variantsData["AllWorkshopPartVariants"] || variantsData["allWorkshopPartVariants"];
      let workshopVariants = variantsData["WorkshopPartVariants"] || variantsData["workshopPartVariants"] || [];

      console.log('→ Data Received - Workshop Variants Count:', workshopVariants.length);
      if (workshopVariants.length > 0) {
        console.log('❗ RAW OBJECT KEYS:', Object.keys(workshopVariants[0]));
        console.log('❗ RAW FIRST ITEM:', JSON.stringify(workshopVariants[0], null, 2));
        console.log('→ First item sample:', workshopVariants[0].PartName, '| Trans:', workshopVariants[0].PartTranslationName || workshopVariants[0].TranslationName);
      }

      // Identify parts that are NOT in workshopVariants (parts without variants)
      // Identify parts that are NOT in workshopVariants (parts without variants)
      const existingPartIds = new Set(workshopVariants.map(v => v.PartId || v.partId));
      const missingParts = (allParts as any[]).filter(p => !existingPartIds.has(p.PartId || p.partId));

      const missingPartVariants = missingParts.map(p => ({
        PartId: p.PartId || p.partId,
        PartName: p.Name || p.name,
        TranslatedPartName: p.Name || p.name,
        VariantId: 0,
        VariantName: null,
        Cost: 0,
        TotalQuantity: 0,
        Quantity: 0,
        Active: true,
        PartImageUrl: p.ImageUrl || p.imageUrl,
        TranslationName: p.TranslationName || p.translationName || p.PartTranslationName,
        PartTranslationName: p.TranslationName || p.translationName || p.PartTranslationName,
        VariantImageUrl: null,
        WorkshopId: workshopId
      }));

      // Merge existing variants with missing parts
      this.bikeDetails = [...workshopVariants, ...missingPartVariants];
      this.allInventoryDetails = this.bikeDetails;

      // Update translations based on current language
      this.applyTranslationLogic(this.bikeDetails);
      this.bikeDetails = [...this.bikeDetails];
      this.allInventoryDetails = [...this.bikeDetails];

      this.loadingIndicator = false;
      this.filterByParts(false);
    }, error => {
      this.loadingIndicator = false;
      this.loggerService.showErrorMessage('Getting parts and variants failed');
    });
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  openPart(part: any) {
    let dialogInfo = {
      width: '500', height: '400'
    };
    this.invDialogRef = this.dialog.open(ImagePopUpDialog, dialogInfo);
    this.parts = {
      Name: part.PartName,
      Url: this.getFormattedImageUrl(part.PartImageUrl, S3BucketFoldersKeys.Parts),
      Description: part.PartDescription
    };
    this.invDialogRef.componentInstance.details = this.parts;
    this.invDialogRef.afterClosed().subscribe(result => {
      this.lastCloseResult = result;
      this.invDialogRef = null;
      this.parts = null;
    });
  }

  openVariant(variant: any) {
    let dialogInfo = {
      width: '500', height: '400'
    };
    this.invDialogRef = this.dialog.open(ImagePopUpDialog, dialogInfo);
    this.parts = {
      Name: variant.VariantName,
      Url: this.getFormattedImageUrl(variant.VariantImageUrl, S3BucketFoldersKeys.Parts),
      Description: variant.VariantDescription
    };
    this.invDialogRef.componentInstance.details = this.parts;
    this.invDialogRef.afterClosed().subscribe(result => {
      this.lastCloseResult = result;
      this.invDialogRef = null;
      this.parts = null;
    });
  }

  private getFormattedImageUrl(imageUrl: string, folder: string): string {
    if (imageUrl && !imageUrl.startsWith('http')) {
      return this.appSettings.s3_Image_URL + folder + '/' + imageUrl;
    }
    return imageUrl;
  }


  /**Start - Workshop related section */

  getAllWorkshopsWithStreetTeam() {
    this.allWorkshops = [];
    this.workshopService.getAllWorkshopsWithStreetTeam().subscribe(res => {
      if (res) {
        this.allWorkshops = res;
      }
    });
  }

  filterBasedOnWorkshop() {
    this.getAllPartVariantsByFilter(this.selectedWorkshop);
  }
  /**End - Workshop related section */

  openAllWorkshopPartDetails(variant: any): void {
    const dialogRef = this.dialog.open(PartRepairInventoryComponent, {
      width: '800px',
      minHeight: '450px',
      data: {
        variant: variant,
        allworkshopPartDetails: this.allworkshopPartDetails,
        allWorkshops: this.allWorkshops,
        selectedWorkshop: this.selectedWorkshop,
        isAdminOrMaintenance: this.isAdminOrMaintenance
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllPartVariantsByFilter(this.selectedWorkshop);
    });
  }

  openAddPartDialog(): void {
    const isMobile = window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;

    const dialogConfig = {
      width: isMobile ? '95%' : isTablet ? '90%' : '800px',
      minHeight: '450px'
    };

    const dialogRef = this.dialog.open(AddPartComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((saved) => {
      if (saved) {
        this.reloadInventoryData();
      }
    });
  }

  openEditPartDialog(part: any): void {
    const isMobile = window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;

    const dialogConfig = {
      width: isMobile ? '95%' : isTablet ? '90%' : '800px',
      minHeight: '450px',
      data: part
    };

    const dialogRef = this.dialog.open(AddPartComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((saved) => {
      if (saved) {
        this.reloadInventoryData();
      }
    });
  }

  private reloadInventoryData() {
    this.loadingIndicator = true;
    this.inventoryService.getAllPartDetails().subscribe(data => {
      this.partsList = data;
      this.applyTranslationLogic(this.partsList);
      this.filteredParts.next(this.partsList.slice());

      // Update selection list (Select all new and old parts)
      this.partCtrl.patchValue([...this.partsList], { emitEvent: false });

      // Refresh the actual inventory rows for the current workshop
      this.getAllPartVariantsByFilter(this.selectedWorkshop);
    }, error => {
      this.loadingIndicator = false;
      this.loggerService.showErrorMessage(error);
    });
  }

  getInventoryPartMappingName(name: string): string {
    let partMappingName;
    switch (name) {
      case 'Battery-controller-ext.cable':
        partMappingName = `${this.partAccessConst}.BATTERY_CONTROLLER_EXT_CABLE`
        break;
      case 'Battery-PCB-ext.cable':
        partMappingName = `${this.partAccessConst}.BATTERY_PCB_EXT_CABLE`
        break;
      case 'Cable to battery ext.cable':
        partMappingName = `${this.partAccessConst}.CABLE_TO_BATTERY_EXT_CABLE`
        break;
      case 'Cable to controller (yellow)':
        partMappingName = `${this.partAccessConst}.CABLE_TO_CONTROLLER_YELLOW`
        break;
      case 'Cable to display (red)':
        partMappingName = `${this.partAccessConst}.CABLE_TO_DISPLAY_RED`
        break;
      case 'Cable to lock (black)':
        partMappingName = `${this.partAccessConst}.CABLE_TO_LOCK_BLACK`
        break;
      case 'Charging/dp-cable':
        partMappingName = `${this.partAccessConst}.CHARGING_DP_CABLE`
        break;
      default:
        partMappingName = `${this.partAccessConst}.${(name || 'UNKNOWN').replace(/ /g, "_").toUpperCase()}`
        break;
    }
    return partMappingName;
  }

  compareParts(o1: any, o2: any): boolean {
    return o1 && o2 ? (o1.PartId || o1.partId) === (o2.PartId || o2.partId) : o1 === o2;
  }

  private applyTranslationLogic(elements: any[]) {
    if (!elements) return;

    const currentLang = this.translate.currentLang || 'en';

    elements.forEach(element => {
      // Standardize property names (handle both camelCase and PascalCase)
      const partName = element.PartName || element.Name || element.partName || element.name || 'Unknown Part';
      const dbTranslation = element.PartTranslationName || element.TranslationName || element.translationName || element.partTranslationName;

      element.PartName = partName; // Standardize for template

      // ENGLISH MODE: Always show the English name from database
      if (currentLang === 'en') {
        element.TranslatedPartName = partName;
        element.TranslationName = dbTranslation; // Preserve for metadata
        return;
      }

      // NORWEGIAN MODE: Check i18n first (legacy), then database (new parts)
      const translationKey = this.getInventoryPartMappingName(partName);
      const i18nTranslation = this.translate.instant(translationKey);
      const hasValidI18n = i18nTranslation !== translationKey &&
        !i18nTranslation.startsWith('INVENTORY.') &&
        String(i18nTranslation).trim() !== '';

      if (hasValidI18n) {
        // Priority 1: Use i18n translation (for legacy parts with existing translations)
        element.TranslatedPartName = String(i18nTranslation);
        element.TranslationName = String(i18nTranslation);
      } else if (dbTranslation && dbTranslation !== 'null' && String(dbTranslation).trim() !== '') {
        // Priority 2: Use database translation (for new manually added parts)
        element.TranslatedPartName = String(dbTranslation);
        element.TranslationName = String(dbTranslation);
      } else {
        // Fallback: Use English name when no translation exists
        element.TranslatedPartName = partName;
        element.TranslationName = null;
      }
    });
  }

  hasWorkshopPrivilegeUser(userId: any) {
    this.userService.getUserPrivilegeByUser(userId).subscribe(res => {
      if (res) {
        let userPrivilege = res;
        if (userPrivilege.PrivilegeId == UserPrivileges.Workshop)
          this.isAdminOrMaintenance = true;
      }
    }, err => {

    });
  }

}
